<template>
	<img class="h-9 md:h-12 max-w-none w-auto" :src="logoUrl" :alt="alt" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "DjLogo",
	props: {
		/**
		 * Region
		 * `hu, ro` — defaults to hu when empty
		 */
		region: {
			type: String,
			default: "",
		},
		alt: {
			type: String,
			default: "Logo DreamJobs",
		},
	},
	computed: {
		logoUrl(): string {
			const key = this.region.toLowerCase() === "ro" ? "ro" : "hu";
			return `/logos/dreamjobs-${key}.png`;
		},
	},
});
</script>
